import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import DetailNavTitle from '@/components/business/detail-nav-title';
import {goBack} from '@/utils';
import React from 'react';
import Text from '@/components/basic/text';
import TriangleIcon from '@/components/svgs/basic/triangle';
import {View} from 'react-native';
import theme from '@/style';

export interface NavHeaderProps {
  selectName?: string;
  onChange?: () => void;
  disabled?: boolean;
}

const NavHeader = ({selectName = '', onChange}: NavHeaderProps) => {
  if (typeof document !== 'undefined') {
    return (
      <div style={stylesWeb.wrap}>
        <button
          onClick={() => {
            goBack();
            localStorage.removeItem('PlayNow');
          }}
          style={stylesWeb.backBtn}
          type="button">
          <span style={stylesWeb.backIcon}>‹</span>
        </button>
        {selectName ? (
          <button
            onClick={() => onChange?.()}
            style={stylesWeb.selectBtn}
            type="button">
            <span style={stylesWeb.selectName}>{selectName}</span>
            <span style={stylesWeb.triangleWrap}>
              <TriangleIcon />
            </span>
          </button>
        ) : null}
      </div>
    );
  }

  return (
    <DetailNavTitle
      hideServer={true}
      leftNode={
        selectName ? (
          <NativeTouchableOpacity
            style={[theme.flex.row, theme.flex.centerByCol]}
            onPress={() => onChange?.()}>
            <View
              style={[
                // eslint-disable-next-line react-native/no-inline-styles
                {
                  maxWidth: 180,
                },
              ]}>
              <Text numberOfLines={1} fontFamily="fontInterBold" size="large">
                {selectName}
              </Text>
            </View>
            {
              <View style={[theme.margin.leftxxs]}>
                <TriangleIcon />
              </View>
            }
          </NativeTouchableOpacity>
        ) : null
      }
      onBack={() => {
        goBack();
        localStorage.removeItem('PlayNow');
      }}
      hideTitle
    />
  );
};

export default NavHeader;

const stylesWeb: Record<string, React.CSSProperties> = {
  wrap: {
    height: '3rem',
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    padding: '0 0.75rem',
    borderBottom: '1px solid #E5E7EB',
  },
  backBtn: {
    width: '2rem',
    height: '2rem',
    border: 'none',
    background: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: 0,
  },
  backIcon: {
    fontSize: '1.75rem',
    lineHeight: '1.75rem',
    color: '#31373D',
  },
  selectBtn: {
    marginLeft: '0.25rem',
    maxWidth: '12rem',
    display: 'flex',
    alignItems: 'center',
    border: 'none',
    background: 'transparent',
    padding: 0,
    cursor: 'pointer',
  },
  selectName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    fontWeight: 700,
    fontFamily: 'Inter-Bold',
    color: '#31373D',
  },
  triangleWrap: {
    marginLeft: '0.25rem',
    display: 'flex',
    alignItems: 'center',
  },
};
